import { fetchCA } from '../../helpers/utils'

/**
 * Fetches facets data from the API.
 * Requires `resultsConfiguration.enableFacets` to be true
 *
 * @param {Object} data - The data to be sent in the request body.
 * @returns {Promise<Object>} The response from the API.
 */
export const apiFetchFacets = async (data) => {
  if (!data) return
  return fetchCA('/facets', {}, 'POST', data)
}

/**
 * Fetches GenAI suggestions from the API.
 * Requires `resultsConfiguration.showGentAIResult` to be true
 *
 * @param {Object} data - The data to be sent in the request body.
 * @returns {Promise<Object>} The response from the API.
 */
export const apiFetchGenAISuggestion = async (data) => {
  if (!data) return
  return fetchCA('/genAI', {}, 'POST', data)
}

/**
 * Ingests LLM response data into the API.
 * Requires `resultsConfiguration.showGentAIResult` to be true
 *
 * @param {Object} data - The data to be sent in the request body.
 * @returns {Promise<Object>} The response from the API.
 */
export const apiIngestLLMResponse = async (data) => {
  if (!data) return
  return fetchCA('/storeAIResponse', {}, 'POST', data)
}

/**
 * Fetches Kendra data from the API.
 * Handles Kendra operations such as query, retrieve, and submitFeedback.
 * @see {@link https://docs.aws.amazon.com/kendra/latest/dg/API_Operations.html Kendra API Operations}
 *
 * @param {Object} data - The data to be sent in the request body.
 * @returns {Promise<Object>} The response from the API.
 */
export const apiFetchKendra = (data) => fetchCA('/kendy', {}, 'POST', data)